import {
  Brain, Route, Settings, Smartphone, WifiOff, Map, Camera, Clock,
  CheckSquare, Users, BarChart, DollarSign, LineChart, Lock, Plug, Sparkles,
} from "lucide-react";

const FEATURES = [
  { Icon: Brain, title: "AI Ticket Prioritization", desc: "Risk-score every ticket before dispatch.", c: "orange" },
  { Icon: Route, title: "Smart Dispatch & Routing", desc: "Assign by location, workload, and skill.", c: "blue" },
  { Icon: Settings, title: "Custom Fields & Workflows", desc: "Configure for any market or customer.", c: "orange" },
  { Icon: Smartphone, title: "Mobile Field App", desc: "iOS and Android with offline mode.", c: "blue" },
  { Icon: WifiOff, title: "Offline Mode", desc: "Works without signal, syncs on reconnect.", c: "orange" },
  { Icon: Map, title: "GIS Map View", desc: "Live ticket map with status color coding.", c: "blue" },
  { Icon: Camera, title: "Photo Evidence", desc: "GPS-tagged, timestamped, auto-organized.", c: "orange" },
  { Icon: Clock, title: "SLA & Compliance Alerts", desc: "Get flagged before tickets go overdue.", c: "blue" },
  { Icon: CheckSquare, title: "Supervisor QA Review", desc: "Approve closeouts before they leave.", c: "orange" },
  { Icon: Users, title: "Customer-Specific Rules", desc: "Different workflows per contract.", c: "blue" },
  { Icon: BarChart, title: "Production & Payroll", desc: "Track output per locator, per day.", c: "orange" },
  { Icon: DollarSign, title: "Billing Support", desc: "Billing-ready closeout packages.", c: "blue" },
  { Icon: LineChart, title: "Executive Dashboards", desc: "Market-level KPIs in real time.", c: "orange" },
  { Icon: Lock, title: "Role-Based Access", desc: "Control what each role sees and does.", c: "blue" },
  { Icon: Plug, title: "API & Integrations", desc: "Connect to 811 feeds, payroll, GIS.", c: "orange" },
  { Icon: Sparkles, title: "AI Assistant", desc: "Ask questions, get operational answers.", c: "blue" },
];

export default function FeatureGrid() {
  return (
    <section data-testid="feature-grid-section" className="section-y relative">
      <div className="container-x">
        <div className="max-w-3xl reveal mb-12">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Platform</div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
            Everything your operation needs. Nothing it doesn't.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {FEATURES.map(({ Icon, title, desc, c }, i) => (
            <div
              key={title}
              className="reveal group rounded-2xl glass p-5 transition-all duration-300 hover:-translate-y-1 hover:border-white/20 hover:shadow-[0_8px_32px_rgba(249,115,22,0.2)]"
              style={{ transitionDelay: `${(i % 4) * 50}ms` }}
            >
              <div
                className={`h-10 w-10 rounded-lg grid place-items-center border mb-4 ${
                  c === "orange"
                    ? "bg-[#F97316]/15 border-[#F97316]/30"
                    : "bg-[#FB923C]/15 border-[#FB923C]/30"
                }`}
              >
                <Icon size={18} className={c === "orange" ? "text-[#F97316]" : "text-[#FDBA74]"} />
              </div>
              <div className="font-display font-bold text-white text-base mb-1.5">{title}</div>
              <div className="text-sm text-[#94A3B8] leading-relaxed">{desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
